module.exports = __webpack_public_path__ + "img/login_background.66a2d295.jpg";